module.exports = ".row:nth-child(odd){\r\n    background: #ececec;   \r\n}\r\n\r\n.row{\r\n    padding: 1em 0px 0px 0px !important;\r\n}\r\n\r\n.mat-form-field-wrapper{\r\n    padding-bottom:0px !important;\r\n}\r\n\r\n.custom-label{\r\n    font-weight: bold;\r\n    }"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/user/user-form/user-form.component.css
// module id = ./src/app/ultilities/user/user-form/user-form.component.css
// module chunks = main